import { getEnvironmentVariable } from "./environmentVariables";
import { MasterPallete } from "./MasterTheme";
const IS_BCP = getEnvironmentVariable("IS_BCP") === "true";
const IS_GW = getEnvironmentVariable("COMPANY_FLAG") === "gw";
const SUPPORTS_DARK_MODE =
  getEnvironmentVariable("SUPPORTS_DARK_MODE") === "true";
const THEME_PALETTE_DARK = getEnvironmentVariable("THEME_PALETTE_DARK");
const THEME_PALETTE_LIGHT = getEnvironmentVariable("THEME_PALETTE_LIGHT");
const THEME_PALETTE_TYPOGRAPHY = getEnvironmentVariable(
  "THEME_PALETTE_TYPOGRAPHY"
);

export const getDesignTokens = (_mode) => {
  var mode =
    getEnvironmentVariable("SUPPORTS_DARK_MODE") === "true" &&
    getEnvironmentVariable("THEME_PALETTE_DARK") !== undefined
      ? _mode
      : "light";
  const AMPLIFY_BRANCH = getEnvironmentVariable("AMPLIFY_BRANCH");

  var palette = {
    ...MasterPallete,
    ...(mode === "dark" ? getDarkPalette() : getLightPalette()),
  };

  return {
    shadows: [
      "none",
      "0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 2px 2px -2px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)",
      "0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)",
    ],
    typography: getTypography(),
    mixins: {},
    components: {
      MuiContainer: {
        styleOverrides: {
          root: { paddingTop: 0, paddingLeft: 0, paddingRight: 0 },
          bodyStyle: { padding: 0 },
        },
      },
      MuiDialog: {
        styleOverrides: {
          root: ({ theme }) => ({
            "& .MuiDialogActions-root .MuiButtonBase-root.MuiButton-root": {
              color:
                mode === "dark"
                  ? `${theme?.palette?.text?.primary} !important`
                  : undefined,
              backgroundColor:
                mode === "dark"
                  ? `${theme?.palette?.primary?.main} !important`
                  : undefined,
            },
          }),
        },
      },
      MuiFormControl: {
        defaultProps:
          mode === "dark" && IS_BCP
            ? { color: "secondary" }
            : { color: "primary" },
      },
      MuiTextField: {
        defaultProps: {
          color: mode === "dark" && IS_BCP ? "secondary" : "primary",
          onWheel: (e) => {
            if (e.target.type === "number") {
              e.target.blur();
            }
          },
        },
        styleOverrides: {
          root: ({ ownerState }) => {
            return {
              ...{
                backgroundColor:
                  IS_GW && !ownerState?.disabled
                    ? palette?.textField?.background || "#fff"
                    : IS_GW && ownerState?.disabled
                      ? "#d5d5d7"
                      : "inherit",
              },
            };
          },
        },
      },
      MuiCheckbox: {
        defaultProps:
          mode === "dark" && IS_BCP
            ? { color: "secondary" }
            : { color: "primary" },
      },
      MuiSelect: {
        defaultProps:
          mode === "dark" && IS_BCP
            ? { color: "secondary" }
            : { color: "primary" },
        styleOverrides: {
          root: ({ ownerState }) => {
            return {
              ...{
                backgroundColor:
                  IS_GW && !ownerState?.disabled
                    ? palette?.textField?.background || "#fff"
                    : IS_GW && ownerState?.disabled
                      ? "#d5d5d7"
                      : "inherit",
              },
            };
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: ({ ownerState }) => {
            return {
              ...{
                backgroundColor: IS_GW
                  ? palette?.textField?.background || "#fff"
                  : "inherit",
              },
            };
          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: ({ ownerState }) => {
            return {
              ...{
                backgroundColor: IS_GW
                  ? palette?.textField?.background || "#fff"
                  : "inherit",
              },
            };
          },
        },
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: ({ ownerState }) => {
            return {
              ...{
                backgroundColor: IS_GW
                  ? palette?.textField?.background || "#fff"
                  : "inherit",
              },
            };
          },
        },
      },
      MuiOutlinedInput: {
        defaultProps:
          mode === "dark" && IS_BCP
            ? { color: "secondary" }
            : { color: "primary" },
        styleOverrides: {
          root: ({ ownerState }) => {
            return {
              ...{
                backgroundColor: IS_GW
                  ? palette?.textField?.background || "#fff"
                  : "inherit",
              },
            };
          },
        },
      },
      MuiInputBase: {
        defaultProps:
          mode === "dark" && IS_BCP
            ? { color: "secondary" }
            : { color: "primary" },
        styleOverrides: {
          root: ({ ownerState }) => {
            return {
              ...{
                backgroundColor: IS_GW
                  ? palette?.textField?.background || "#fff"
                  : "inherit",
              },
            };
          },
        },
      },
      MuiSwitch: {
        defaultProps:
          mode === "dark" && IS_BCP
            ? { color: "secondary" }
            : { color: "primary" },
      },
      MuiSwitchBase: {
        styleOverrides: {
          root: ({ ownerState }) => {
            return {
              ...{
                backgroundColor:
                  IS_GW && ownerState?.type === "radio"
                    ? palette?.textField?.background || "#fff"
                    : "inherit",
              },
            };
          },
        },
      },
      MuiTabs: {
        defaultProps: { indicatorColor: null, textColor: "inherit" },
        styleOverrides: {
          root: ({ ownerState }) => {
            return {
              ...{
                backgroundColor: "inherit",
                color: palette.banner?.contrastText,
                "& .MuiTab-root": {
                  textTransform: "none",
                },
                "& .MuiTabs-indicator": {
                  ...(!ownerState?.indicatorColor && {
                    backgroundColor: palette.banner?.contrastText,
                  }),
                },
              },
            };
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }) => {
            let colors = ownerState?.color?.split(".");
            return {
              textTransform: "none",
              fontSize: "16px",
              borderRadius: IS_GW ? "4px" : "8px",
              ...(ownerState?.variant === "outlined" &&
                mode === "dark" && {
                  backgroundColor:
                    palette[colors[0] || "primary"]?.[
                      colors[1] || "contrastText"
                    ],
                  "&:hover": {
                    backgroundColor: palette[colors[0] || "primary"]?.dark,
                    color:
                      palette[colors[0] || "primary"]?.[
                        colors[1] || "contrastText"
                      ],
                  },
                }),
              ...(ownerState?.variant === "outlined" &&
                IS_GW && {
                  color: ownerState?.disabled
                    ? "text.disabled"
                    : palette[colors[0] || "primary"]?.[
                        colors[1] || "contrastText"
                      ],
                  backgroundColor: "#ffffff",
                }),
              ...(ownerState?.variant === "outlined" && mode === "dark"
                ? {
                    backgroundColor:
                      palette[colors[0] || "primary"]?.[
                        colors[1] || "contrastText"
                      ],
                    "&:hover": {
                      backgroundColor: palette[colors[0] || "primary"]?.dark,
                      color:
                        palette[colors[0] || "primary"]?.[
                          colors[1] || "contrastText"
                        ],
                    },
                  }
                : ownerState?.variant === "contained" &&
                    ownerState?.color === "primary" &&
                    (AMPLIFY_BRANCH === "catan-gold" ||
                      AMPLIFY_BRANCH === "catan-dev" ||
                      AMPLIFY_BRANCH === "catan-prod")
                  ? { border: "1px solid #fcde06" }
                  : null),
            };
          },
        },
      },
      MuiIconButton: {
        variants: [
          {
            props: { variant: "contained" },
            style: ({ ownerState }) => {
              let colors = ownerState?.color?.split(".");
              return {
                ...{
                  color:
                    palette[colors[0] || "primary"]?.[
                      colors[1] || "contrastText"
                    ] || "inherit",

                  backgroundColor:
                    palette[colors[0] || "primary"]?.main || "inherit",
                  "&:hover": {
                    backgroundColor:
                      palette[colors[0] || "primary"]?.dark || "inherit",
                  },
                },
              };
            },
          },
        ],
      },
      MuiLink: {
        defaultProps: { color: "link.main" },
        styleOverrides: {
          root: ({ ownerState }) => {
            let colors = ownerState?.color?.split(".");
            return {
              color:
                palette[colors[0] || "link"]?.[colors[1] || "main"] ||
                "inherit",
            };
          },
        },
      },
      MuiPickersLayout: {
        styleOverrides: {
          root: ({ theme }) => ({
            "&  .MuiDialogActions-root .MuiButtonBase-root.MuiButton-root": {
              color:
                mode === "dark"
                  ? `${theme?.palette?.text?.primary} !important`
                  : undefined,
              backgroundColor:
                mode === "dark"
                  ? `${theme?.palette?.primary?.main} !important`
                  : undefined,
            },
          }),
        },
      },
    },
    palette: palette,
  };
};

const getLightPalette = () => {
  let palette = defaultLightPalette;
  if (THEME_PALETTE_LIGHT !== undefined) {
    try {
      palette = JSON.parse(THEME_PALETTE_LIGHT);
    } catch (err) {}
  }

  return palette;
};

const getDarkPalette = () => {
  let palette = getLightPalette() || {};
  if (SUPPORTS_DARK_MODE && THEME_PALETTE_DARK !== undefined) {
    try {
      let dPalette = JSON.parse(THEME_PALETTE_DARK);
      palette = {
        ...palette,
        ...dPalette,
      };
    } catch (err) {}
  }

  return palette;
};

const getTypography = () => {
  let typography = defaultTypography;
  if (THEME_PALETTE_TYPOGRAPHY !== undefined) {
    try {
      typography = JSON.parse(THEME_PALETTE_TYPOGRAPHY);
    } catch (err) {}
  }

  return typography;
};

const defaultLightPalette = {
  mode: "light",
  type: "light",
  text: {
    primary: "#0F0F13",
    secondary: "#676B79",
    error: "#db2c6f",
    message: "#7b1fa2",
    disabled: "#757575",
  },
  background: {
    default: "#FFFFFF",
    primary: "#EEEEEE",
    secondary: "#FFFFFF",
    tertiary: "#BBBBBB",
  },
  primary: {
    contrastText: "#ffffff",
    main: "#2E2B9D",
    light: "#5755b0",
    dark: "#201e6d",
  },
  secondary: {
    contrastText: "#0F0F13",
    main: "#66B6FF",
    light: "#a54747",
    dark: "#477fb2",
  },
  link: {
    contrastText: "#ffffff",
    main: "#2E2B9D",
    light: "#5755b0",
    dark: "#201e6d",
    stripe: "#7b1fa2",
    square: "#006aff",
  },
  banner: {
    contrastText: "#0F0F13",
    main: "#EEEEEE",
    light: "#FFFFFF",
    dark: "#BBBBBB",
  },
  modal: {
    text: "#0F0F13",
    background: "#FFFFFF",
  },
  border: {
    main: "rgba(0, 0, 0, 0.23)",
    light: "#52525b",
  },
  drawer: {
    contrastText: "#172b4d",
    main: "#F0F2F5",
    background: "#F0F2F5",
    light: "#f3f4f7",
    dark: "#a8a9ab",
  },
  table: {
    headerBackground: "#1B51A0",
    headerColor: "#fff",
    oddRowBackground: "#fff",
    evenRowBackground: "#EEEEEE",
    rowColor: "#000",
  },
};

const defaultTypography = {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    letterSpacing: "-0.24px",
  },
  h2: {
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: "-0.24px",
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: "-0.06px",
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: "-0.06px",
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: "0.25px",
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
  },
  overline: {
    fontWeight: 500,
  },
};
